import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Mail, Globe } from 'lucide-react';
interface SlideCTAProps {
  onContinue: () => void;
}
export function SlideCTA({
  onContinue
}: SlideCTAProps) {
  const [stage, setStage] = useState(0);
  useEffect(() => {
    const t1 = setTimeout(() => setStage(1), 200);
    const t2 = setTimeout(() => setStage(2), 700);
    const t3 = setTimeout(() => setStage(3), 1400);
    const t4 = setTimeout(() => setStage(4), 2100);
    return () => {
      ;
      [t1, t2, t3, t4].forEach(clearTimeout);
    };
  }, []);
  return <div className="h-full w-full flex items-center justify-center px-8 py-8 md:px-16 md:py-12 bg-white relative overflow-hidden" data-id="element-261" data-mp="j23l1xdg5nt1">
      {/* Subtle background watermark */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: stage >= 1 ? 1 : 0
    }} transition={{
      duration: 1.2
    }} className="pointer-events-none absolute inset-0 flex items-center justify-center -mt-32" data-id="element-262" data-mp="o0es60ccxk7k">
        <span className="text-[14vw] font-bold tracking-tight text-slate-100 select-none" data-id="element-263" data-mp="2fuw1vvzvn6eh">
          snakker
        </span>
      </motion.div>

      <div className="relative z-10 max-w-5xl w-full" data-id="element-264" data-mp="25y9jreyxqtg5">
        {/* Headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: stage >= 1 ? 1 : 0,
        y: stage >= 1 ? 0 : 20
      }} transition={{
        duration: 0.7
      }} className="text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight leading-[1.05] text-slate-900" data-id="element-265" data-mp="20zpx1ccipdmq">
          The legacy long tail is worth billions.
        </motion.h1>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: stage >= 2 ? 1 : 0,
        y: stage >= 2 ? 0 : 20
      }} transition={{
        duration: 0.7
      }} className="text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight leading-[1.05] mt-1" data-id="element-266" data-mp="2jy10vokr0pyd">
          <span className="bg-gradient-to-r from-sky-400 via-indigo-400 to-[#6C2BD9] bg-clip-text text-transparent" data-id="element-267" data-mp="1fnh7dewengp2">
            Snakker is how pharma finally captures it.
          </span>
        </motion.h2>

        {/* Subtitle */}
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: stage >= 3 ? 1 : 0,
        y: stage >= 3 ? 0 : 10
      }} transition={{
        duration: 0.6
      }} className="text-lg md:text-2xl text-slate-500 font-medium mt-8 max-w-3xl leading-relaxed" data-id="element-268" data-mp="15ww9xusgwi7q">
          Procurement-cleared with 15 of the top 30 pharma companies. A
          closed-loop operating model that turns every HCP interaction into a
          sharper next campaign. Ready to scale — let's talk.
        </motion.p>

        {/* Contact cards */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: stage >= 4 ? 1 : 0,
        y: stage >= 4 ? 0 : 16
      }} transition={{
        duration: 0.6
      }} className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8 max-w-3xl" data-id="element-269" data-mp="5pzl10xjsj2w">
          <a href="mailto:mh@snakker.io" className="group flex items-center gap-4 rounded-2xl py-3 px-2 hover:bg-slate-50 transition-colors" data-id="element-270" data-mp="ao161rejash0">
            <div className="w-12 h-12 rounded-full bg-[#F5F0FF] flex items-center justify-center text-[#6C2BD9] flex-shrink-0 group-hover:scale-105 transition-transform" data-id="element-271" data-mp="jhxkek1gj0lv">
              <Mail className="w-5 h-5" data-id="element-272" data-mp="thoiswt51zr8" />
            </div>
            <div className="text-left" data-id="element-273" data-mp="306jm4ibhz4h1">
              <p className="text-[10px] uppercase tracking-[0.2em] text-slate-400 font-bold" data-id="element-274" data-mp="307mb2kp9ewub">
                Contact
              </p>
              <p className="text-base md:text-lg font-bold text-slate-900 mt-0.5" data-id="element-275" data-mp="2va2ydp87ms4h">
                Morten Hjelmsø · mh@snakker.io
              </p>
            </div>
          </a>

          <a href="https://www.snakker.io" target="_blank" rel="noreferrer" className="group flex items-center gap-4 rounded-2xl py-3 px-2 hover:bg-slate-50 transition-colors" data-id="element-276" data-mp="1r81mx6llblo0">
            <div className="w-12 h-12 rounded-full bg-[#F5F0FF] flex items-center justify-center text-[#6C2BD9] flex-shrink-0 group-hover:scale-105 transition-transform" data-id="element-277" data-mp="13ka89wckuwjk">
              <Globe className="w-5 h-5" data-id="element-278" data-mp="18hahgg4q4few" />
            </div>
            <div className="text-left" data-id="element-279" data-mp="1cjxdkt8fgmhw">
              <p className="text-[10px] uppercase tracking-[0.2em] text-slate-400 font-bold" data-id="element-280" data-mp="1civrltpvifle">
                Visit
              </p>
              <p className="text-base md:text-lg font-bold text-slate-900 mt-0.5" data-id="element-281" data-mp="ku2fo86i7ohm">
                www.snakker.io
              </p>
            </div>
          </a>
        </motion.div>
      </div>
    </div>;
}